"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraformingGanymede = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var LogHelper_1 = require("../../LogHelper");
var CardRenderer_1 = require("../render/CardRenderer");
var TerraformingGanymede = (function (_super) {
    __extends(TerraformingGanymede, _super);
    function TerraformingGanymede() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.TERRAFORMING_GANYMEDE,
            tags: [Tags_1.Tags.JOVIAN, Tags_1.Tags.SPACE],
            cost: 33,
            metadata: {
                cardNumber: '197',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tr(1).slash().jovian().played;
                }),
                description: 'Raise your TR 1 step for each Jovian tag you have, including this.',
                victoryPoints: 2,
            },
        }) || this;
    }
    TerraformingGanymede.prototype.canPlay = function (player) {
        var steps = 1 + player.getTagCount(Tags_1.Tags.JOVIAN);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST * steps, { titanium: true });
        }
        return true;
    };
    TerraformingGanymede.prototype.play = function (player) {
        var steps = 1 + player.getTagCount(Tags_1.Tags.JOVIAN);
        player.increaseTerraformRatingSteps(steps);
        LogHelper_1.LogHelper.logTRIncrease(player, steps);
        return undefined;
    };
    TerraformingGanymede.prototype.getVictoryPoints = function () {
        return 2;
    };
    return TerraformingGanymede;
}(Card_1.Card));
exports.TerraformingGanymede = TerraformingGanymede;
//# sourceMappingURL=TerraformingGanymede.js.map